import styled from 'styled-components'

export const LoadingLabel = styled.span`
	margin-left: -3px;
	color: ${({ theme }) => theme.color.input.contentLoading};
	align-self: center;
`
